"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { ChangeAnimation, NumberDisplay } from "@opensea/ui-kit";
export const StatsTableRowOwnersFragment = graphql(`
  fragment StatsTableRowOwners on Collection {
    stats {
      ownerCount
    }
  }
`);
export function StatsTableRowOwners(t0) {
  const $ = _c(7);
  const {
    collection: key
  } = t0;
  let t1;
  if ($[0] !== key) {
    t1 = readFragment(StatsTableRowOwnersFragment, key);
    $[0] = key;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  let t2;
  if ($[2] !== collection.stats.ownerCount) {
    t2 = <NumberDisplay display="full" value={collection.stats.ownerCount} />;
    $[2] = collection.stats.ownerCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== collection.stats.ownerCount || $[5] !== t2) {
    t3 = <ChangeAnimation display="full" value={collection.stats.ownerCount}>{t2}</ChangeAnimation>;
    $[4] = collection.stats.ownerCount;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}